import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSortModule } from '@angular/material/sort'
import { MatTableModule } from '@angular/material/table'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'

import { AdvancedTableComponent } from './advanced-table.component'
import { AdvancedTableRxComponent } from './advanced-table-rx.component'
import { CellTemplateDirective } from './cell-template.directive'
import { NormalizeDecimalPipe } from './normalize-decimal.pipe'

const declarations = [
  AdvancedTableComponent,
  AdvancedTableRxComponent,
  CellTemplateDirective,
  NormalizeDecimalPipe,
]

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatTooltipModule,
    PipesModule,
    RouterModule, // needed so RouterLink will work
    TranslateModule,
  ],
  exports: [...declarations],
  declarations: [...declarations],
})
export class AdvancedTableModule {}
